(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbJackpotLib", [], factory);
	else if(typeof exports === 'object')
		exports["sbJackpotLib"] = factory();
	else
		root["sbJackpotLib"] = factory();
})(window, function() {
return 